// 带扩展名:本文件会被 test/style-safe-area.test.mjs 用 Node ESM 直接 import,
// Node 不做 webpack 那套无扩展名解析。
import { LAUNCHER, launcherTransition } from './component-contract.js';

export const desktopWrapperStyle = {
    position: 'fixed',
    bottom: '20px',
    right: '20px',
    zIndex: 2147483647,
    borderRadius: 'var(--lc-radius-lg)',
    // 暗色主题：--lc-* 变量只在暗色生效时才被定义（widget.js _syncThemeCssVars
    // 写到 shadow host 上），亮色下 var() 走 fallback —— 计算值与历史逐字节一致。
    background: 'var(--lc-surface, #ffffff)',
    boxSizing: 'content-box',
    boxShadow: 'var(--lc-shadow-3)',
    border: 'none',
    overflow: 'hidden'
};

export const desktopClosedWrapperStyleChat = {
    position: 'fixed',
    bottom: '0px',
    right: '0px',
    zIndex: 2147483647,
    minWidth: '400px',
    boxSizing: 'content-box',
    overflow: 'hidden',
    minHeight: '120px'
};

export const mobileClosedWrapperStyle = {
    position: 'fixed',
    bottom: 18,
    right: 18,
    zIndex: 2147483647,
    borderRadius: 'var(--lc-radius-full)',
    // wrapper 透明：内部 ChatFloatingButton 自带颜色背景；
    // 之前 #ffffff 在 ChatFloatingButton scale(0→1) 入场动画时会露出白色圆 → 闪光
    background: 'transparent',
    boxSizing: 'content-box'
};

export const mobileOpenWrapperStyle = {
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 2147483647,
    width: '100%',
    height: '100%',
    background: 'var(--lc-surface, #ffffff)',
    overflowY: 'visible',
    boxSizing: 'content-box'
};

export const desktopTitleStyle = {
    // 面板打开态是 flex 列（header + flex:1 内容区）；header 绝不能被压缩，
    // 否则内容多的时候 header 会被挤矮、高度模型就对不上了。
    flexShrink: 0,
    height: '72px',
    lineHeight: '24px',
    fontSize: '16px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0 var(--lc-space-4)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    color: '#fff',
    // cursor:pointer 故意不设——header 背景本身不可点击(点空白区域已经是 no-op，
    // 见 widget.js Widget.onClick 结尾的说明)，只有里面的具体控件(tab/关闭/语言/
    // 设置)才应该表现出"可点"。整块 header 显示手型指针会让人以为点哪都有反应，
    // 点在标题/头像/空白上却什么都不发生——这是这次要修的"看起来能点、其实是
    // 陷阱"问题本身。
    WebkitTapHighlightColor: 'transparent',    // 去掉 iOS/Android 点击灰色蒙层——header 仍然挂着 onClick
                                                // 做 tab 事件委托(点 tab 冒泡上来才路由)，这个属性只是不让
                                                // 委托目标之外的区域被误点时也在原生容器里闪一下深色蒙层。
    borderRadius: 'var(--lc-radius-lg) var(--lc-radius-lg) 0 0',
    position: 'relative',
    overflow: 'hidden',
};

// 启动器的基础壳。直径/圆角/高程/过渡曲线全部读组件契约表 LAUNCHER ——
// 这颗按钮 macOS SDK 也要画一颗一模一样的，值留在这里就只能靠抄。
export const mobileTitleStyle = {
    height: LAUNCHER.diameterPx,
    width: LAUNCHER.diameterPx,
    cursor: 'pointer',
    borderRadius: `var(${LAUNCHER.radiusToken})`,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: `var(${LAUNCHER.shadowToken})`,
    transition: launcherTransition(['transform', 'box-shadow']),
};

export const chatHeaderStyle = {
    display: 'flex',
    margin: '0 auto',
};

export const chatHeaderSubStyle = {
    display: 'flex',
    margin: '0 auto',
    zIndex: 1,
    gap: 'var(--lc-space-1)',
};

// 内置 header 碎图模式（inline SVG data URI）
export const headerPatterns = {
    // 四角星（默认）— 内联 data URI，与 dash WidgetConfig 预览同一份（勿再引外部 CDN）
    stars: {
        url: `url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8 4l4 2-4 2-2 4-2-4-4-2 4-2 2-4z' fill-rule='evenodd'/%3E%3C/svg%3E")`,
        size: '32px',
    },
    // 圆点阵列
    dots: {
        url: `url("data:image/svg+xml,%3Csvg width='20' height='20' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='10' cy='10' r='2' fill='white'/%3E%3C/svg%3E")`,
        size: '20px',
    },
    // 网格线
    grid: {
        url: `url("data:image/svg+xml,%3Csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M24 0v24H0' fill='none' stroke='white' stroke-width='0.5'/%3E%3C/svg%3E")`,
        size: '24px',
    },
    // 波浪线
    waves: {
        url: `url("data:image/svg+xml,%3Csvg width='40' height='20' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 10 Q10 0 20 10 T40 10' fill='none' stroke='white' stroke-width='1.2'/%3E%3C/svg%3E")`,
        size: '40px 20px',
    },
    // 空心圆
    circles: {
        url: `url("data:image/svg+xml,%3Csvg width='30' height='30' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='15' cy='15' r='8' fill='none' stroke='white' stroke-width='0.8'/%3E%3C/svg%3E")`,
        size: '30px',
    },
    // 对角线
    diagonal: {
        url: `url("data:image/svg+xml,%3Csvg width='16' height='16' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 16L16 0' fill='none' stroke='white' stroke-width='0.8'/%3E%3C/svg%3E")`,
        size: '16px',
    },
    // 三角形
    triangles: {
        url: `url("data:image/svg+xml,%3Csvg width='28' height='24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M14 4L24 20H4Z' fill='none' stroke='white' stroke-width='0.8'/%3E%3C/svg%3E")`,
        size: '28px 24px',
    },
    // 十字
    crosses: {
        url: `url("data:image/svg+xml,%3Csvg width='20' height='20' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10 4v12M4 10h12' fill='none' stroke='white' stroke-width='1'/%3E%3C/svg%3E")`,
        size: '20px',
    },
    // 六边形蜂巢
    hexagons: {
        url: `url("data:image/svg+xml,%3Csvg width='28' height='48' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M14 0L28 8v16l-14 8L0 24V8z' fill='none' stroke='white' stroke-width='0.7'/%3E%3Cpath d='M14 48L28 40V24l-14-8L0 24v16z' fill='none' stroke='white' stroke-width='0.7'/%3E%3C/svg%3E")`,
        size: '28px 48px',
    },
    // 菱形
    diamonds: {
        url: `url("data:image/svg+xml,%3Csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12 2L22 12L12 22L2 12Z' fill='none' stroke='white' stroke-width='0.8'/%3E%3C/svg%3E")`,
        size: '24px',
    },
    // 交错砖块
    bricks: {
        url: `url("data:image/svg+xml,%3Csvg width='32' height='16' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 0h32v8H0zM16 8h32v8H16zM-16 8h32v8h-32z' fill='none' stroke='white' stroke-width='0.6'/%3E%3C/svg%3E")`,
        size: '32px 16px',
    },
    // 闪电/锯齿
    zigzag: {
        url: `url("data:image/svg+xml,%3Csvg width='24' height='16' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 16L6 0L12 16L18 0L24 16' fill='none' stroke='white' stroke-width='0.8'/%3E%3C/svg%3E")`,
        size: '24px 16px',
    },
    // 花瓣/叶形
    leaves: {
        url: `url("data:image/svg+xml,%3Csvg width='30' height='30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M15 5 Q25 15 15 25 Q5 15 15 5Z' fill='none' stroke='white' stroke-width='0.7'/%3E%3C/svg%3E")`,
        size: '30px',
    },
    // 星星（六角星）
    star6: {
        url: `url("data:image/svg+xml,%3Csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12 2l3 7h7l-5.5 4.5L18.5 21 12 17l-6.5 4 2-7.5L2 9h7z' fill='none' stroke='white' stroke-width='0.7'/%3E%3C/svg%3E")`,
        size: '24px',
    },
    // 散点圆（大小交替）
    bubbles: {
        url: `url("data:image/svg+xml,%3Csvg width='40' height='40' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='10' cy='10' r='4' fill='none' stroke='white' stroke-width='0.7'/%3E%3Ccircle cx='30' cy='30' r='6' fill='none' stroke='white' stroke-width='0.7'/%3E%3Ccircle cx='30' cy='8' r='2.5' fill='white' opacity='0.6'/%3E%3C/svg%3E")`,
        size: '40px',
    },
    // 弧形鱼鳞
    scales: {
        url: `url("data:image/svg+xml,%3Csvg width='20' height='20' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 20 A10 10 0 0 1 20 20' fill='none' stroke='white' stroke-width='0.7'/%3E%3Cpath d='M10 10 A10 10 0 0 1 30 10' fill='none' stroke='white' stroke-width='0.7'/%3E%3Cpath d='M-10 10 A10 10 0 0 1 10 10' fill='none' stroke='white' stroke-width='0.7'/%3E%3C/svg%3E")`,
        size: '20px',
    },
    // 无碎图
    none: null,
};

// ---------- 沉浸式状态栏适配（fill 布局专属，见 widget.js _isFillFullPage） ----------
// iOS 真机反馈：全面屏改造去掉导航栏后，widget header 的渐变背景直接顶到
// 状态栏底下（这本身是想要的"沉浸感"），但标题/头像/关闭按钮等**内容**也跟着
// 顶到最上面，跟系统时钟/电量重叠。修法：header 的高度/顶部内边距同步加一份
// env(safe-area-inset-top)——背景（整个盒子）延伸进安全区，内容（padding 撑开
// 的可用区域）保持原有尺寸不变、只是整体下移了安全区那么多。只在 fill 布局下
// 生效；浏览器直接打开时 env()=0，天然无操作，不需要额外按 platform= 参数门控。
export const SAFE_AREA_TOP = 'env(safe-area-inset-top, 0px)';
export const SAFE_AREA_BOTTOM = 'env(safe-area-inset-bottom, 0px)';

/**
 * 把一个像素高度值升级成"外加安全区"的 calc() 表达式。
 * @param {number|string} basePx 原有的高度/内边距值（纯数字按 px 处理，也接受
 *   已经是字符串的 CSS 长度）
 * @param {boolean} active 是否要叠加安全区（调用方传 _isFillFullPage() 的结果）
 * @param {string} envVar 用哪个 env() 变量，默认顶部；底部传 SAFE_AREA_BOTTOM
 */
export function withSafeAreaTop(basePx, active, envVar = SAFE_AREA_TOP) {
    const base = typeof basePx === 'number' ? `${basePx}px` : basePx;
    return active ? `calc(${base} + ${envVar})` : base;
}

/**
 * 把一个 CSS 长度值（数字按 px 处理，字符串原样接受——包括已经是 calc() 的
 * 表达式，CSS 允许嵌套 calc）取负，用于 background-position 的纵向偏移。
 * 数字和 calc 字符串都能套进去，调用方不用关心内部是不是本来就是 calc()。
 */
export function negateAsCssLength(value) {
    if (!value) return '0px';
    const expr = typeof value === 'number' ? `${value}px` : value;
    return `calc(-1 * (${expr}))`;
}

/**
 * @param {string} patternName
 * @param {number|string} offsetY 纹样平铺的纵向偏移（px，或已经组装好的 CSS
 *   calc() 表达式字符串——fill 布局下 header 高度本身就带 env(safe-area-
 *   inset-top)，见 negateAsCssLength）。Home 首页把 header 和欢迎区
 *   拼成一条连续的 hero：欢迎区传入「header 高度 − 已滚动距离」，纹样才会接着
 *   header 继续铺，而不是从自己的左上角重新起铺（那样接缝处星星对不上）。
 *   减去滚动距离是因为欢迎区在滚动容器内、会跟着内容上移，而 header 不动 ——
 *   不减的话只有 scrollTop=0 那一刻对得上，一滚就错位。
 *   可以为负（欢迎区被滚到 header 上方时）。
 */
export function getHeaderPatternStyle(patternName, offsetY = 0) {
    const pattern = headerPatterns[patternName] || headerPatterns.stars;
    if (!pattern) {
        return { display: 'none' };
    }
    return {
        backgroundImage: pattern.url,
        backgroundSize: pattern.size,
        // negateAsCssLength 统一取负，数字和 calc() 字符串（fill 布局 + 安全区）都能套
        backgroundPosition: offsetY ? `0 ${negateAsCssLength(offsetY)}` : undefined,
        opacity: 0.075,
        content: '""',
        backgroundRepeat: 'repeat',
        position: 'absolute',
        inset: 0,
        zIndex: 0,
        height: '100%',
    };
}

// Home 首页 hero 的虚拟渐变盒高度。header 与欢迎区都按这个高度绘制同一个渐变，
// 欢迎区再按 header 高度向上偏移 —— 于是两块拼起来是一条连续的渐变，而不是
// 各画各的、在接缝处颜色跳变。取值要大于 header + 欢迎区的实际总高。
export const HOME_HERO_BG_HEIGHT = 320;

/**
 * Home 首页 hero 的背景样式。
 * @param {object} theme
 * @param {number|string} offsetY 0 = header 自己；欢迎区传「header 高度 − 已滚动
 *   距离」（同 getHeaderPatternStyle，可为负，也接受 calc() 字符串）
 */
export function homeHeroBackgroundStyle(theme, offsetY = 0) {
    const grad = theme && theme.headerGradient;
    const solid = (theme && theme.mainColor) || '#2563eb';
    // 纯色不存在"接缝处颜色跳变"的问题，直接用回原来的写法
    if (!grad) return { background: solid };
    return {
        backgroundColor: solid,          // 偏移后万一露边，用主色兜底而不是露白
        backgroundImage: grad,
        backgroundSize: `100% ${HOME_HERO_BG_HEIGHT}px`,
        backgroundPosition: `0 ${negateAsCssLength(offsetY)}`,
        backgroundRepeat: 'no-repeat',
    };
}

// 默认 pattern style（向后兼容）
export const chatHeaderBeforeStyle = getHeaderPatternStyle('stars');

export const chatBackStyle = {
    height: '30px',
    padding: '0 10px',
    textAlign: 'center',
    position: 'absolute',
    lineHeight: '30px',
    top: 'calc((72px - 30px) / 2)',
    background: 'rgba(255, 255, 255, 0.15)',
    borderRadius: 'var(--lc-radius-sm)',
};

export const chatSmallStyle = {
    lineHeight: '24px',
    pointerEvents: 'auto',
    margin: '0',
    padding: '6px 16px',
    display: 'flex',
    alignItems: 'center',
    gap: 'var(--lc-space-2)',
    borderRadius: 'var(--lc-radius-md)',
    fontSize: '14px',
    fontWeight: '500',
    color: '#fff',
    background: 'rgba(255, 255, 255, 0.2)',
    backdropFilter: 'blur(4px)',
    transition: 'background var(--lc-dur-base) var(--lc-ease-out), transform var(--lc-dur-base) var(--lc-ease-out), opacity var(--lc-dur-base) var(--lc-ease-out)',
    cursor: 'pointer',
    WebkitTapHighlightColor: 'transparent',    // 同 desktopTitleStyle：tab 本身也吃 header 委托点击
};

// tab 内的图标槽：inline-flex + 居中 + lineHeight:0。
// 之前是普通 inline <span>（width:15px, height:auto），里面的 <svg> 按 baseline 对齐 ——
// span 的盒高 = svg 高 + 基线以下的行内 descender 空隙，父级 align-items:center 居中的是
// 这个"带尾巴"的盒子，于是 svg 本身被顶得比文字视觉重心高一两像素。固定 15×15 的方形槽
// + flex 居中把这条 inline 基线规则整个绕开，两个 viewBox 不同的图标（1168×1024 / 1024×1024）
// 也能落在同一条视觉中线上。
export const chatIconStyle = {
    width: '15px',
    height: '15px',
    flexShrink: 0,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    lineHeight: 0,
};

export const chatIconSvgStyle = {
    width: '15px',
    height: 'auto',
    display: 'block',        // 不参与行内基线布局
    verticalAlign: 'middle', // 兜底：万一落到 inline 上下文里也按中线对齐
    flexShrink: 0,
};

export const closeButtonStyle = {
    position: 'absolute',
    top: '50%',
    right: '12px',
    transform: 'translateY(-50%)',
    background: 'rgba(255, 255, 255, 0.15)',
    border: 'none',
    outline: 'none',                           // 去掉 :focus outline 闪烁
    WebkitTapHighlightColor: 'transparent',    // iOS 点击灰白蒙层
    WebkitAppearance: 'none',
    appearance: 'none',
    color: '#fff',
    fontSize: '16px',
    cursor: 'pointer',
    padding: '6px',
    lineHeight: '1',
    opacity: 0.9,
    borderRadius: 'var(--lc-radius-sm)',
    transition: 'background var(--lc-dur-base) var(--lc-ease-out), opacity var(--lc-dur-base) var(--lc-ease-out)',
    zIndex: 10,
    width: '32px',
    height: '32px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
};

export const serviceTitleStyle = {
    fontSize: '16px',
    fontWeight: '600',
    color: '#fff',
    marginBottom: '2px',
    lineHeight: '1.4',
};

export const guideTextStyle = {
    fontSize: '12px',
    color: 'rgba(255, 255, 255, 0.8)',
    lineHeight: '1.4',
    fontWeight: '400',
};

export const serviceInfoWrapperStyle = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: '0 var(--lc-space-2)',
    flex: 1,
};

export const fabCloseButtonStyle = {
    position: 'fixed',
    bottom: '20px',
    right: '20px',
    width: '56px',
    height: '56px',
    borderRadius: 'var(--lc-radius-full)',
    background: 'rgba(0, 0, 0, 0.6)',
    border: 'none',
    outline: 'none',                           // 去掉 :focus 默认 outline 闪烁
    WebkitTapHighlightColor: 'transparent',    // 去掉 iOS/Android 点击灰色蒙层
    WebkitAppearance: 'none',                  // 干掉 iOS Safari 的默认 button 圆角阴影
    appearance: 'none',
    color: '#fff',                             // 让 :active 时浏览器不会回退到默认色
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    boxShadow: 'var(--lc-shadow-2)',
    zIndex: 2147483646,
    /* 不动 bottom/right/width/height，避免 appConfig 加载完后从默认位置 → 配置位置的 1-2px 抖动 */
    transition: 'transform var(--lc-dur-slow) var(--lc-ease-spring), box-shadow var(--lc-dur-slow) var(--lc-ease-out), opacity var(--lc-dur-slow) var(--lc-ease-out)',
};

// Chat list button style for header
export const chatListButtonStyle = {
    background: 'rgba(255, 255, 255, 0.15)',
    border: 'none',
    color: '#fff',
    fontSize: '16px',
    cursor: 'pointer',
    WebkitTapHighlightColor: 'transparent',    // 同 desktopTitleStyle
    padding: '6px',
    borderRadius: 'var(--lc-radius-sm)',
    transition: 'background var(--lc-dur-base) var(--lc-ease-out), transform var(--lc-dur-base) var(--lc-ease-out), opacity var(--lc-dur-base) var(--lc-ease-out)',
    width: '32px',
    height: '32px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 'var(--lc-space-1)',
};
